import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const MenuPage = () => {
  return (
    <div className="page-transition">
      {/* Hero Section */}
      <section className="bg-gradient-hero py-16 lg:py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="font-display text-4xl lg:text-5xl font-bold text-primary-foreground mb-4">
            Our Menu
          </h1>
          <p className="text-primary-foreground/80 text-lg max-w-xl mx-auto">
            Simple food, done right. No fancy descriptions, just honest grub.
          </p>
        </div>
      </section>

      {/* Meal Deal Section */}
      <section className="py-12 bg-wheat/10 border-y border-wheat/20">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <Card className="bg-card border-2 border-wheat/30 shadow-card">
              <CardContent className="p-6 lg:p-8 text-center">
                <Badge className="bg-wheat text-wheat-foreground mb-4">Best Value</Badge>
                <h2 className="font-display text-2xl lg:text-3xl font-bold text-foreground mb-2">
                  Meal Deal
                </h2>
                <p className="text-muted-foreground text-lg mb-4">
                  Sandwich, Hashbrown & a Drink
                </p>
                <p className="font-display text-4xl font-bold text-accent">£4.95</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Menu Categories */}
      <section className="py-16 lg:py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto space-y-12">
            
            {/* Bacon Sandwich */}
            <Card className="bg-card border-border shadow-card">
              <CardHeader className="pb-4">
                <div className="flex justify-between items-start">
                  <CardTitle className="font-display text-2xl lg:text-3xl text-foreground">
                    Bacon Sandwich
                  </CardTitle>
                  <span className="font-display text-2xl font-bold text-accent">£3.50</span>
                </div>
              </CardHeader>
              <CardContent className="space-y-6">
                {/* Choose Bacon */}
                <div>
                  <h4 className="font-semibold text-foreground mb-3">Choose Bacon</h4>
                  <div className="flex gap-4">
                    <span className="text-muted-foreground">• Streaky</span>
                    <span className="text-muted-foreground">• Back</span>
                  </div>
                </div>

                {/* Upgrades */}
                <div className="border-t border-border pt-4">
                  <h4 className="font-semibold text-foreground mb-3">Upgrades</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">+ Thick Cut Bacon</span>
                      <span className="font-display font-bold text-accent">+£1.00</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">+ Double the Pig</span>
                      <span className="font-display font-bold text-accent">+£2.00</span>
                    </div>
                  </div>
                </div>

                {/* Choose Bread */}
                <div className="border-t border-border pt-4">
                  <h4 className="font-semibold text-foreground mb-3">Choose Bread</h4>
                  <div className="flex flex-wrap gap-4">
                    <span className="text-muted-foreground">• Farmhouse</span>
                    <span className="text-muted-foreground">• Seeded</span>
                    <span className="text-muted-foreground">• Sourdough</span>
                  </div>
                </div>

                {/* Add Sauce */}
                <div className="border-t border-border pt-4">
                  <h4 className="font-semibold text-foreground mb-3">Add Sauce</h4>
                  <div className="flex flex-wrap gap-4">
                    <span className="text-muted-foreground">• Ketchup</span>
                    <span className="text-muted-foreground">• HP</span>
                    <span className="text-muted-foreground">• None</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Sides */}
            <Card className="bg-card border-border shadow-card">
              <CardHeader className="pb-4">
                <CardTitle className="font-display text-2xl lg:text-3xl text-foreground">
                  Sides
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex justify-between items-center py-3">
                  <span className="font-medium text-foreground text-lg">Hashbrown</span>
                  <span className="font-display text-xl font-bold text-accent">£1.50</span>
                </div>
              </CardContent>
            </Card>

            {/* Hot Drinks */}
            <Card className="bg-card border-border shadow-card">
              <CardHeader className="pb-4">
                <CardTitle className="font-display text-2xl lg:text-3xl text-foreground">
                  Hot Drinks
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                {/* Tea */}
                <div>
                  <h4 className="font-semibold text-foreground mb-3">Cuppa Tea</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between py-2">
                      <span className="text-muted-foreground">White</span>
                      <span className="font-display font-bold text-accent">£1.50</span>
                    </div>
                    <div className="flex justify-between py-2">
                      <span className="text-muted-foreground">Black</span>
                      <span className="font-display font-bold text-accent">£1.50</span>
                    </div>
                  </div>
                </div>

                {/* Coffee */}
                <div className="border-t border-border pt-4">
                  <h4 className="font-semibold text-foreground mb-3">Cuppa Coffee</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between py-2">
                      <span className="text-muted-foreground">White</span>
                      <span className="font-display font-bold text-accent">£1.95</span>
                    </div>
                    <div className="flex justify-between py-2">
                      <span className="text-muted-foreground">Black</span>
                      <span className="font-display font-bold text-accent">£1.95</span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

          </div>

          {/* CTA */}
          <div className="text-center mt-12">
            <Button asChild variant="hero" size="xl">
              <Link to="/order">Order via WhatsApp</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MenuPage;
